import Vue from 'vue';
import Vuex from 'vuex';
import ModuleView from './modules/ModuleView';
import ModuleAnalytics from './modules/ModuleAnalytics';
Vue.use(Vuex);

export default new Vuex.Store({
    /**
     * модули
     * @property {object} ModuleView - модуль с информацией о странице
     * @property {object} ModuleAnalytics - модуль аналитики менеджеров
     */
    modules: {
        ModuleView,
        ModuleAnalytics 
    },
    /**
     * @property {string} activeProjectId - идентификатор активного проекта (пока что хардкодом)
     */
    state: {
        activeProjectId: "1",
        filterSelected: {},
        searchText: ""
    },
    mutations: {
        /**
         * установить текущий выбранный фильтр
         * @param {object} state - объект состояний
         * @param {object} selected - текущее название
         */
        setFilterSelected(state, selected) {
            state.filterSelected = selected;
        },

        /**
         * 
         * @param {object} state - объект состояний
         * @param {String} searchText
         */
        setSearchText(state, searchText) {
            state.searchText = searchText;
        },
    },
    actions: {

    }
});
